<template>
  <div class="">
    <b-nav vertical class="text-center sidebar bg-dark">
      <!--<b-nav-item class="hvr-pulse-shrink mt-3" @click="toRoute('/admin/home')">-->
      <!--<router-link active-class="hvr-pulse-grow active" class="sidebar-link" to="home"-->
      <!--v-b-popover.hover="'Edit Home Page'">-->
      <!--<icon-vue icon="home"></icon-vue>-->
      <!--</router-link>-->
      <!--</b-nav-item>-->

      <!--<b-nav-item class="hvr-pulse-shrink" @click="toRoute('/admin/about')">-->
      <!--<router-link active-class="hvr-pulse-grow active" class="sidebar-link" to="about"-->
      <!--v-b-popover.hover="'Edit About Page'">-->
      <!--<icon-vue icon="address-book"></icon-vue>-->
      <!--</router-link>-->
      <!--</b-nav-item>-->

      <!--<b-nav-item class="hvr-pulse-shrink"-->
      <!--@click="toRoute('/admin/carnival')">-->
      <!--<router-link active-class="hvr-pulse-grow active" class="sidebar-link" to="carnival"-->
      <!--v-b-popover.hover="'Edit Carnival Page'">-->
      <!--<icon-vue :icon="['fas', 'air-freshener']"></icon-vue>-->
      <!--</router-link>-->
      <!--</b-nav-item>-->

      <!--<b-nav-item class="hvr-pulse-shrink"-->
      <!--@click="toRoute('/admin/contact')">-->
      <!--<router-link active-class="hvr-pulse-grow active" class="sidebar-link" to="contact"-->
      <!--v-b-popover.hover="'Edit Contact Page'">-->
      <!--<icon-vue icon="phone-square"></icon-vue>-->
      <!--</router-link>-->
      <!--</b-nav-item>-->

      <!--<b-nav-item class="hvr-pulse-shrink"-->
      <!--@click="toRoute('/admin/tickets')">-->
      <!--<router-link active-class="hvr-pulse-grow active" class="sidebar-link" to="tickets"-->
      <!--v-b-popover.hover="'Edit Tickets Page'">-->
      <!--<icon-vue icon="ticket-alt"></icon-vue>-->
      <!--</router-link>-->
      <!--</b-nav-item>-->

      <b-nav-item class="hvr-pulse-shrink" @click="toRoute('/admin/schedule')">
        <router-link
          active-class="hvr-pulse-grow active"
          class="sidebar-link"
          to="schedule"
          v-b-popover.hover="'Scheduler'"
        >
          <icon-vue :icon="['far', 'clock']"></icon-vue>
        </router-link>
      </b-nav-item>

      <b-nav-item
        class="hvr-pulse-shrink"
        @click="toRoute('/admin/performance-areas')"
      >
        <router-link
          active-class="hvr-pulse-grow active"
          class="sidebar-link"
          to="performance-areas"
          v-b-popover.hover="'Performance Areas'"
        >
          <icon-vue icon="theater-masks"></icon-vue>
        </router-link>
      </b-nav-item>

      <b-nav-item
        class="hvr-pulse-shrink"
        @click="toRoute('/admin/event-info')"
      >
        <router-link
          active-class="hvr-pulse-grow active"
          class="sidebar-link"
          to="event-info"
          v-b-popover.hover="'Event Information'"
        >
          <icon-vue :icon="['far', 'calendar-alt']"></icon-vue>
        </router-link>
      </b-nav-item>
      <b-nav-item class="hvr-pulse-shrink" @click="toRoute('/admin/images')">
        <router-link
          active-class="hvr-pulse-grow active"
          class="sidebar-link"
          to="images"
          v-b-popover.hover="'Images'"
        >
          <icon-vue :icon="['far', 'images']"></icon-vue>
        </router-link>
      </b-nav-item>
      <b-nav-item class="hvr-pulse-shrink" @click="toRoute('/admin/files')">
        <router-link
          active-class="hvr-pulse-grow active"
          class="sidebar-link"
          to="files"
          v-b-popover.hover="'Files'"
        >
          <icon-vue icon="folder"></icon-vue>
        </router-link>
      </b-nav-item>
      <b-nav-item class="hvr-pulse-shrink" @click="toRoute('/admin/footer')">
        <router-link
          active-class="hvr-pulse-grow active"
          class="sidebar-link"
          to="footer"
          v-b-popover.hover="'Footer Content'"
        >
          <icon-vue icon="link"></icon-vue>
        </router-link>
      </b-nav-item>
      <b-nav-item class="hvr-pulse-shrink" @click="toRoute('/admin/history')">
        <router-link
          active-class="hvr-pulse-grow active"
          class="sidebar-link"
          to="history"
          v-b-popover.hover="'Themes History'"
        >
          <icon-vue icon="book-open"></icon-vue>
        </router-link>
      </b-nav-item>

      <b-nav-item class="hvr-pulse-shrink" @click="toRoute('/admin/settings')">
        <router-link
          active-class="hvr-pulse-grow active"
          class="sidebar-link"
          to="settings"
          v-b-popover.hover="'Settings'"
        >
          <icon-vue icon="user-cog"></icon-vue>
        </router-link>
      </b-nav-item>

      <b-nav-item
        class="hvr-pulse-shrink"
        @click="toRoute('/admin/newsletter')"
      >
        <router-link
          active-class="hvr-pulse-grow active"
          class="sidebar-link"
          to="newsletter"
          v-b-popover.hover="'Newsletter Subscribers'"
        >
          <icon-vue icon="newspaper"></icon-vue>
        </router-link>
      </b-nav-item>

      <b-nav-item class="hvr-pulse-shrink" @click="toRoute('/admin/fliers')">
        <router-link
          active-class="hvr-pulse-grow active"
          class="sidebar-link"
          to="fliers"
          v-b-popover.hover="'Fliers'"
        >
          <icon-vue icon="sticky-note"></icon-vue>
        </router-link>
      </b-nav-item>
      <b-nav-item class="hvr-pulse-shrink" @click="toRoute('/admin/galleries')">
        <router-link
          active-class="hvr-pulse-grow active"
          class="sidebar-link"
          to="galleries"
          v-b-popover.hover="'galleries'"
        >
          <icon-vue :icon="['far', 'images']"></icon-vue>
        </router-link>
      </b-nav-item>

      <!--<b-nav-item class="hvr-pulse-shrink">-->
      <!--<router-link active-class="hvr-pulse-grow active" class="sidebar-link" to="create-admin"-->
      <!--v-b-popover.hover="'Add Admin'">-->
      <!--<icon-vue icon="user-plus"></icon-vue>-->
      <!--</router-link>-->
      <!--</b-nav-item>-->

      <b-nav-item v-b-popover.hover="'Log out'" class="hvr-pulse-shrink">
        <!--<router-link active-class="active" class="sidebar-link text-danger" to="performance-areas">-->
        <icon-vue icon="sign-out-alt" @click="logout"></icon-vue>
        <!--</router-link>-->
      </b-nav-item>
    </b-nav>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
/*@import "@/assets/sass/admin"*/
.sidebar {
  /*width: 50px;*/
  height: 100%;
  position: fixed;
}

.sidebar-link {
  color: #ffffff;
  /*left: 0;*/
  /*transition: left 0.3s;*/
  /*-webkit-transition: left 0.3s;*/
}

.sidebar-link:hover {
  /*position: relative;*/
  /*left: 5px;*/
  color: #c69500;
}

a.sidebar-link.active > svg {
  /*background: #ffffff;*/
  /*position: relative;*/
  /*left: 4px;*/
  color: #0062cc;
}
</style>
